import { useEffect, useState } from "react";
import React from "react";
import { useAuth0 } from "@auth0/auth0-react";
import useCsr from "../hooks/useCsr";

const findEmailField = user => {
  const emailRegex = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i;
  for (const key in user) {
    if (emailRegex.test(user[key])) {
      return user[key];
    }
  }
  return null;
};

const formatTicketSubject = path => {
  const parts = path.split("/");
  const formattedParts = parts.map(part => {
    if (/^\d+$/.test(part)) {
      return part;
    } else if (part.toLowerCase() === "csr") {
      return "CSR";
    } else {
      return part
        .split("-")
        .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
        .join(" ");
    }
  });
  return formattedParts.join(" ");
};

const HubspotForm = ({ region, portalId, formId, trigger }) => {
  const [showForm, setShowForm] = useState();
  const { user } = useAuth0();
  const { currentStudyName } = useCsr();

  useEffect(() => {
    if (showForm) {
      const script = document.createElement("script");
      script.src = "https://js-eu1.hsforms.net/forms/embed/v2.js";
      document.body.appendChild(script);

      script.addEventListener("load", () => {
        if (window.hbspt) {
          const form = window.hbspt.forms.create({
            region: region,
            portalId: portalId,
            formId: formId,
            target: "#hubspotForm",
          });
          form.onReady(function () {
            const currentPage = window.location.pathname.replace(
              /^\/|\/$/g,
              ""
            );
            let ticketSubject = formatTicketSubject(currentPage);
            if (currentStudyName) {
              ticketSubject += " " + currentStudyName;
            }
            const emailField = findEmailField(user);
            if (emailField) {
              form.setFieldValue("email", emailField);
            }
            form.setFieldValue("TICKET.subject", ticketSubject);
          });
        }
      });

      return () => {
        document.body.removeChild(script);
      };
    }
  }, [showForm, region, portalId, formId, user]);

  const handleClick = e => {
    e.preventDefault();
    setShowForm(true);
  };

  const handleCloseModal = () => {
    setShowForm(false);
  };

  return (
    <>
      {React.cloneElement(trigger, { onClick: handleClick })}
      {showForm && (
        <div className="footer__modal">
          <div className="footer__modal-content">
            <span className="footer__modal-close" onClick={handleCloseModal}>
              &times;
            </span>
            <div id="hubspotForm"></div>
          </div>
        </div>
      )}
    </>
  );
};

export default HubspotForm;
